import { calculateNEISBytes, getSaenggibuOfficialMaxBytes } from './neisBytes';

// 행동특성은 학년 전체가 한 칸이라 1학기 글과 2학기 글이 같은 한도를 나눠 쓴다.
const YEARLY_FIELD = new Set(['행동발달']);
const MIN_REMAINING_BYTES = 300;
// AI 결과는 목표보다 학생 한 명이 최대 12%쯤 길게 나온다. 운영 1학기 글 72명으로 재 보니 여유 없이는 4~18%가
// 1학기 글과 합쳐 한도를 넘었고, 100바이트를 남기면 0명이었다(평균 합계는 한도의 90%).
const SAFETY_MARGIN_BYTES = 100;

/** 명단 학년도 1학기(3월~8월)에 쓴 같은 영역 글. 학생마다 가장 최근 글 하나. */
export const findPriorSemesterTexts = (recordStudents = [], { category, schoolYear }) => {
  const cutoff = `${schoolYear}-09-01`;
  const bySid = {};
  recordStudents.forEach((student) => {
    const latest = (student.items || [])
      .filter((item) => item.kind === 'saenggibu' && item.category === category && String(item.content || '').trim())
      .filter((item) => item.date && String(item.date) < cutoff)
      .sort((a, b) => String(b.date).localeCompare(String(a.date)))[0];
    if (latest) bySid[student.sid] = latest.content;
  });
  return bySid;
};

const median = (values) => {
  const sorted = [...values].sort((a, b) => a - b);
  return sorted.length ? sorted[Math.floor(sorted.length / 2)] : 0;
};

/**
 * 학년 전체 한 칸인 영역이면 남은 분량을 계산한다. 1학기 글 길이의 가운데 값과 여유분을 빼고 50바이트 단위로 내린다.
 * 지금 목표보다 늘리지는 않는다.
 */
export const priorSemesterTarget = (texts = [], { category, schoolLevel = '중등', wordCount }) => {
  if (!YEARLY_FIELD.has(category) || texts.length === 0) return null;
  const limit = getSaenggibuOfficialMaxBytes(category, schoolLevel);
  const priorBytes = median(texts.map((text) => calculateNEISBytes(text)));
  const remaining = Math.max(MIN_REMAINING_BYTES, Math.floor((limit - priorBytes - SAFETY_MARGIN_BYTES) / 50) * 50);
  return { limit, priorBytes, targetBytes: Math.min(Number(wordCount) || remaining, remaining) };
};
